import React, { useCallback, useState } from 'react';
import { connect } from "react-redux";
import InventorySearchForm from './InventorySearchForm.js';
import { useHistory, useParams } from 'react-router-dom';
const tabs = [

];
const OMTransactionHistoryMain = (props) => {
  const history = useHistory();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
      history.push('/om/history');
    }
  }, []);
  const [filteredTabs, setFilteredTabs] = useState(tabs);
  return (
    <div>

            <InventorySearchForm selectedTab = "History" />
        
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMTransactionHistoryMain);